/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';
import type { CaricoMezzoDTO } from './CaricoMezzoDTO';
import {
    CaricoMezzoDTOFromJSON,
    CaricoMezzoDTOFromJSONTyped,
    CaricoMezzoDTOToJSON,
} from './CaricoMezzoDTO';
import type { CaricoOraDTO } from './CaricoOraDTO';
import {
    CaricoOraDTOFromJSON,
    CaricoOraDTOFromJSONTyped,
    CaricoOraDTOToJSON,
} from './CaricoOraDTO';

/**
 * 
 * @export
 * @interface AllevamentoCreateDTO
 */
export interface AllevamentoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    idNazione: string;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllevamentoCreateDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof AllevamentoCreateDTO
     */
    banca?: BancaDTO;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoCreateDTO
     */
    idAllevatore?: number;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    codiceAllevamento?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    descrizioneBreve?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    personaRiferimento?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoCreateDTO
     */
    idTecnico?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllevamentoCreateDTO
     */
    caricoGiorno?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    maxCaricoGiorno?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoCreateDTO
     */
    minutiTrasferimento?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    pesa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    incompatibile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoCreateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {CaricoOraDTO}
     * @memberof AllevamentoCreateDTO
     */
    caricoOra?: CaricoOraDTO;
    /**
     * 
     * @type {CaricoMezzoDTO}
     * @memberof AllevamentoCreateDTO
     */
    caricoMezzo?: CaricoMezzoDTO;
}

/**
 * Check if a given object implements the AllevamentoCreateDTO interface.
 */
export function instanceOfAllevamentoCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idNazione" in value;

    return isInstance;
}

export function AllevamentoCreateDTOFromJSON(json: any): AllevamentoCreateDTO {
    return AllevamentoCreateDTOFromJSONTyped(json, false);
}

export function AllevamentoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllevamentoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
        'idAllevatore': !exists(json, 'idAllevatore') ? undefined : json['idAllevatore'],
        'codiceAllevamento': !exists(json, 'codiceAllevamento') ? undefined : json['codiceAllevamento'],
        'descrizioneBreve': !exists(json, 'descrizioneBreve') ? undefined : json['descrizioneBreve'],
        'personaRiferimento': !exists(json, 'personaRiferimento') ? undefined : json['personaRiferimento'],
        'idTecnico': !exists(json, 'idTecnico') ? undefined : json['idTecnico'],
        'caricoGiorno': !exists(json, 'caricoGiorno') ? undefined : json['caricoGiorno'],
        'maxCaricoGiorno': !exists(json, 'maxCaricoGiorno') ? undefined : json['maxCaricoGiorno'],
        'minutiTrasferimento': !exists(json, 'minutiTrasferimento') ? undefined : json['minutiTrasferimento'],
        'pesa': !exists(json, 'pesa') ? undefined : json['pesa'],
        'incompatibile': !exists(json, 'incompatibile') ? undefined : json['incompatibile'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'caricoOra': !exists(json, 'caricoOra') ? undefined : CaricoOraDTOFromJSON(json['caricoOra']),
        'caricoMezzo': !exists(json, 'caricoMezzo') ? undefined : CaricoMezzoDTOFromJSON(json['caricoMezzo']),
    };
}

export function AllevamentoCreateDTOToJSON(value?: AllevamentoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
        'idAllevatore': value.idAllevatore,
        'codiceAllevamento': value.codiceAllevamento,
        'descrizioneBreve': value.descrizioneBreve,
        'personaRiferimento': value.personaRiferimento,
        'idTecnico': value.idTecnico,
        'caricoGiorno': value.caricoGiorno,
        'maxCaricoGiorno': value.maxCaricoGiorno,
        'minutiTrasferimento': value.minutiTrasferimento,
        'pesa': value.pesa,
        'incompatibile': value.incompatibile,
        'note': value.note,
        'caricoOra': CaricoOraDTOToJSON(value.caricoOra),
        'caricoMezzo': CaricoMezzoDTOToJSON(value.caricoMezzo),
    };
}

